<template>
  <Vehicles />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import Vehicles from '@/components/content/Vehicles.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'VehiclesView',
  components: { Vehicles },
  setup(props, context) {
    const i18n = useI18n()
    context.emit('pageName', i18n.t('aside.menu.pages.vehicles'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.vehicles'))
    })
  }
})
</script>